import { render, staticRenderFns } from "./message-detail.vue?vue&type=template&id=1e534ae6"
import script from "./message-detail.vue?vue&type=script&lang=ts"
export * from "./message-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports